import { index, staff_list, reasons, store} from "@/api/additionalWork/additionalWork";

export const actions = {    
    index({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
            index(params).then(res => {                
                commit("SET_LIST", res.data.result.data.additionalWorks);
                commit("UPDATE_PAGINATION", { key: 'total', value: res.data.result.data.pagination.total });
                resolve(res)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    store({ commit }, data) {
      return new Promise((resolve, reject) => {
          store(data)
              .then(res => {
                  resolve(res);
              })
              .catch(err => {
                  reject(err);
              });
      });
  },


    staff_list({ commit }, params={}) {
      return new Promise((resolve, reject) => {
        staff_list(params)
              .then(res => {
                  commit("SET_STAFF_LIST", res.data.result.data.staffs);                    
                  resolve(res.data.result.data.staffs);
              })
              .catch(err => {
                  reject(err.response.data);
              });
      });
    },
    getDepartmentStaffList({ commit }, params={}) {
      return new Promise((resolve, reject) => {
          getDepartmentStaffList(params)
              .then(res => {
                  commit("SET_STAFF_LIST", res.data.result.data.staffs);                    
                  resolve(res.data.result.data.staffs);
              })
              .catch(err => {
                  reject(err.response.data);
              });
      });
    },

    getDepartmentStaffListIzn({ commit }, params={}) {
      return new Promise((resolve, reject) => {
        getDepartmentStaffListIzn(params)
              .then(res => {
                  commit("SET_STAFF_LIST", res.data.result.data.staffs);                    
                  resolve(res.data.result.data.staffs);
              })
              .catch(err => {
                  reject(err.response.data);
              });
      });
    },
    getDepartmentStaffListNotComeIn({ commit }, params={}) {
      return new Promise((resolve, reject) => {
        getDepartmentStaffListNotComeIn(params)
              .then(res => {
                  commit("SET_STAFF_LIST", res.data.result.data.staffs);                    
                  resolve(res.data.result.data.staffs);
              })
              .catch(err => {
                  reject(err.response.data);
              });
      });
    },
    reasons({ commit } ) {
      return new Promise((resolve, reject) => {
          reasons()
              .then(res => {
                  commit("SET_REASONS", res.data.result.data.reasons);
                  // commit("UPDATE_PAGINATION", { key: 'total', value: res.data.result.data.pagination.total });
                  resolve(res.data.result.data.reasons);
              })
              .catch(err => {
                  reject(err.response.data);
              });
      });
    },
    updateSort({ commit }, sort) {
      commit("SET_SORT", sort)
  },

  updateFilter({ commit }, filter) {
      commit('SET_FILTER', JSON.parse(JSON.stringify(filter)))
  },

  updateColumn({ commit }, obj) {
      commit('UPDATE_COLUMN', obj)
  },
  updatePagination({ commit }, pagination) {
      commit('UPDATE_PAGINATION', pagination)
  },
  refreshData({ commit }) {
      return new Promise((resolve, reject) => {
          commit("REFRESH");
          resolve()
      })
  },
  empty({ commit }) {
    return new Promise((resolve, reject) => {
        commit("EMPTY_MODEL");
        resolve()
    })
},
};
